import axios from "axios";
import { GETCLIENTKEY, GETCLIENTSTRIPE } from "../index";

export const getClientKeyData = (postData) => {
  return axios.post(GETCLIENTKEY, JSON.stringify(postData));
};

export const getClientStripeData = (postData) => {
  return axios.post(GETCLIENTSTRIPE, JSON.stringify(postData));
};